export const features = [
  {
    key: 'bdd',
    title: 'Données 100 % FR',
    subtitle: 'IA hébergée en France',
    iconFamily: 'fa-solid',
    icon: 'database',
  },
  {
    key: 'support',
    title: 'Support 24/7',
    subtitle: 'des experts IA à votre écoute',
    iconFamily: 'fa-regular',
    icon: 'heart',
  },
  {
    key: 'security',
    title: 'Sécurité & conformité 24/7',
    subtitle: 'au cœur de notre ADN',
    iconFamily: 'fa-solid',
    icon: 'shield',
  },
]
